import {bindActionCreators} from 'redux';
import noop from 'lodash/noop';

export const createComponent = ({role, props = noop, actions = {}, init = noop} = {}) => (
  controllerConfig,
  store,
  externalProps
) => {
  if (!store || !controllerConfig) {
    return;
  }

  const getProps = () => props(store.getState());
  const mergeExternalProps = p => Object.assign(p || {}, externalProps || {});
  let lastProps = getProps();
  let components;

  // setup render, that will call given function initially and when props change
  const render = fn => {
    fn(lastProps);
    store.subscribe(() => {
      const nextProps = getProps();
      if (lastProps !== nextProps) {
        lastProps = nextProps;
        fn(mergeExternalProps(lastProps));
      }
    });
  };

  // get components: either for one role or many roles if object of roles is passed
  if (typeof role === 'string') {
    controllerConfig.$w(`@${role}`).forEach(comps => {
      components = comps;
    });
  } else {
    const roleToComponents = {};
    for (const roleName of Object.keys(role)) {
      controllerConfig.$w(`@${role[roleName]}`).forEach(comps => {
        roleToComponents[roleName] = comps;
      });
    }
    components = Object.keys(roleToComponents).length > 0 ? roleToComponents : null;
  }

  // bind actions
  const boundActions = bindActionCreators(actions, store.dispatch);

  if (!components) {
    return;
  }

  init(components, {props: mergeExternalProps(lastProps), actions: boundActions, getProps, render, store});
};
